import { ComponentMultiStyleConfig } from '@chakra-ui/react'

export const ImageCard: ComponentMultiStyleConfig = {
  parts: ['figure', 'link', 'figcaption'],
  baseStyle: {
    figure: {
      width: {
        base: '300px',
        sm: '100%',
        md: '100%',
      },
    },
    link: {
      textDecoration: 'none',
      color: 'currentColor',
    },
    figcaption: {
      marginBottom: 2.5,
    },
    heading: {
      fontSize: { base: '1rem', sm: '1.125rem' },
      fontWeight: 500,
      marginTop: '0.75rem',
    },
  },
}
